import { useResolvedPath } from '..';

/**
 * Hook which returns the current resolved path (part of URL that matches the current route)
 */
export const useCurrentResolvedPath = (): string => useResolvedPath('').pathname;
